import { Column } from '../enum/Column';
import store, { AppDispatch } from '../store/store';
import { isFilterDependentColumn } from './table-helper';
import { updateApplicationConfig } from './update-config';

/**
 * Persists the current table column configuration from the Redux store
 * to the application configuration state/storage.
 *
 * Columns that are dynamically controlled by filters
 * (such as device, device type, and payment type columns)
 * are excluded from persistence, since their visibility
 * depends on the current filter state and should not
 * be restored after refresh or login.
 *
 * @param dispatch - Redux dispatch function used for updating configuration state.
 */

const removeTransientColumns = (columns: Column[]) => {
  return columns.filter((column) => !isFilterDependentColumn(column.name));
};

export const persistColumnConfig = (dispatch: AppDispatch) => {
  const columnsByPage = store.getState().configSlice.columnsByPage;

  const persistedColumnsByPage = Object.fromEntries(
    Object.entries(columnsByPage).map(([page, columns]) => [page, removeTransientColumns(columns as Column[])]),
  );

  updateApplicationConfig(
    {
      columnsByPage: persistedColumnsByPage,
    },
    dispatch,
  );
};
